import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export const SiteNav = ({ onOpenBlogPosts }) => {
  const { settings } = useSettings();
  const { pathname } = useLocation();

  const linkBase =
    "font-display font-bold text-xs md:text-sm tracking-[0.22em] uppercase transition-opacity";
  const navItemActive = "opacity-100";
  const navItemIdle = "opacity-50 hover:opacity-100";

  return (
    <nav
      data-testid="top-nav"
      className="absolute top-0 left-0 right-0 z-40 flex items-center justify-between px-6 md:px-10 py-5"
    >
      <Link
        to="/"
        data-testid="brand-link"
        className="flex items-center gap-3 text-white mix-blend-difference"
      >
        <div className="w-2.5 h-2.5 bg-[#FF2A00] rounded-full" />
        <span className={linkBase}>{settings.brand_name}</span>
      </Link>

      <div className="flex items-center gap-5 md:gap-7 text-white mix-blend-difference">
        {onOpenBlogPosts ? (
          <button
            type="button"
            data-testid="open-blog-posts-btn"
            onClick={onOpenBlogPosts}
            className={`group flex items-center gap-2.5 ${linkBase} ${
              pathname === "/" ? navItemActive : navItemIdle
            }`}
          >
            <span>{settings.blog_posts_label}</span>
            <span className="grid place-items-center w-7 h-7 border border-white group-hover:bg-white group-hover:text-black transition-colors">
              <ArrowUpRight size={14} strokeWidth={2.5} />
            </span>
          </button>
        ) : (
          <Link
            to="/"
            data-testid="open-blog-posts-link"
            className={`${linkBase} ${navItemIdle}`}
          >
            {settings.blog_posts_label}
          </Link>
        )}

        <Link
          to="/about"
          data-testid="about-me-link"
          className={`${linkBase} ${
            pathname === "/about" ? navItemActive : navItemIdle
          }`}
        >
          About Me
        </Link>
      </div>
    </nav>
  );
};

export default SiteNav;
